// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__BhyNp","description":"PatientConsentPreview_description__Qa7U2"};